import { render, staticRenderFns } from "./SafeName.vue?vue&type=template&id=3bd3da29&scoped=true&"
import script from "./SafeName.vue?vue&type=script&lang=js&"
export * from "./SafeName.vue?vue&type=script&lang=js&"
import style0 from "./SafeName.vue?vue&type=style&index=0&id=3bd3da29&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3bd3da29",
  null
  
)

export default component.exports